<template>
  <div>
    <van-popup
      v-model="show"
      round
      position="bottom"
      :close-on-click-overlay="false"
      :style="{ height:'94%'}"
      safe-area-inset-bottom
      @open="onOpen"
      @closed="onClosed"
    >
      <div class="head">
        <van-row type="flex" align="center">
          <van-col span="16" offset="4" style="text-align:center">
            <strong>全部 {{commentsCount}} 条评论</strong>
          </van-col>
          <van-col span="4" style="text-align:right;padding-right:15px;">
            <van-icon name="close" @click="closeComments" /></van-col>
        </van-row>
      </div>
      <div style="margin:35px 0;padding:10px 0px;">
        <div v-if="mostLiked.length > 0">
          <van-divider>精彩评论</van-divider>
          <van-cell
            v-for="commentId in mostLiked" :key="commentId">
            <CommentDetail
              :comment-id="commentId"
              v-on:reply-to="replyTo"
              v-on:comment-closed="commentClosed"
            />
            <!-- <CommentThread
              :comment-id="commentId"
              v-on:reply-to="replyTo"
              :ref="'commentThread' + commentId"
            /> -->
          </van-cell>
        </div>
        <van-divider v-if="mostLiked.length > 0">最新评论</van-divider>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :immediate-check="false"
          @load="loadMore"
        >
          <van-cell
            v-for="comment in comments" :key="comment.id">
            <CommentDetail
              :comment-id="comment.id"
              v-on:reply-to="replyTo"
              v-on:comment-closed="commentClosed"
            />
            <!-- <CommentThread
              :comment-id="comment.id"
              v-on:reply-to="replyTo"
              :ref="'commentThread' + comment.id"
            /> -->
          </van-cell>
        </van-list>
      </div>

      <div class="bottom-bar">
        <van-row type="flex" align="center">
          <van-col span="20">
            <van-field
              ref="commentInput"
              v-model="commentValue"
              :placeholder="placeholder"
              @blur="onBlur"
              style="width:100%;"/>
          </van-col>
          <van-col span="4" style="text-align:center;">
            <van-button
              plain
              type="info"
              size="normal"
              style="border:none"
              @click="submit"
            >
              发布
            </van-button>
          </van-col>
        </van-row>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import Vue from 'vue'
  import CommentDetail from './comment-detail.vue'
  // import CommentThread from './comment-thread.vue'
  import { Popup } from 'vant'
  import { Sticky } from 'vant'
  import { Row, Col } from 'vant'
  import { List } from 'vant'
  import { Cell, CellGroup } from 'vant'
  import { Field } from 'vant'
  import { Notify } from 'vant'
  import { Toast } from 'vant'
  import { Divider } from 'vant'
  Vue.use(Popup)
  Vue.use(Sticky)
  Vue.use(Row).use(Col)
  Vue.use(List)
  Vue.use(Cell).use(CellGroup)
  Vue.use(Field)
  Vue.use(Notify)
  Vue.use(Toast)
  Vue.use(Divider)

  export default {
    components: {
      CommentDetail
      // CommentThread
    },
    props: {
      commentsShow: Boolean,
      commentApplabel: String,
      commentClassname: String,
      commentObjectid: Number
    },
    data () {
      return {
        show: false,
        list: [],
        next: '',
        commentsCount: 0,
        mostLiked: [], // 赞最多的评论列表
        comments: [],
        loading: false,
        finished: false,
        commentValue: '',
        applabel: '',
        classname: '',
        objectid: 0,
        parent: null, // 父级评论
        replyToUserName: '', // 被回复的用户昵称
      }
    },
    computed: {
      placeholder () {
        let text
        if (this.replyToUserName) {
          text = `回复 ${this.replyToUserName}：`
        } else { text = '添加你的评论...' }
        return text
      }
    },
    watch: {
      commentsShow (val) {
        if (val == true) {
          this.show = true
        } else {
          this.show = false
        }
      }
    },
    methods: {
      onOpen () {
        window.console.log("评论窗口被显示")
        this.get_comments()
      },
      onClosed () {
        this.list = []
        this.next = null
        this.commentsCount = 0
        this.mostLiked = []
        this.comments = []
        this.loading = false
        this.finished = false
        this.commentValue = ''
        this.applabel = ''
        this.classname = ''
        this.objectid = 0
        this.parent = null // 父级评论
        this.replyToUserName = '' // 被回复的用户昵称
      },
      get_comments () {
        window.console.log("执行获取评论。。。")
        let that = this
        that.applabel = that.commentApplabel
        that.classname = that.commentClassname
        that.objectid = that.commentObjectid
        let params = {
          applabel: that.commentApplabel,
          classname: that.commentClassname,
          objectid: that.commentObjectid
        }

        that.$api.comment.most_liked(params).then(res => {
          window.console.log("获取了赞数最多的评论列表")
          window.console.log(res)
          that.mostLiked = res.data
        })

        that.$api.comment.list(params).then(res => {
          that.comments = res.data.results
          window.console.log("获取到的that.comments是：")
          window.console.log(that.comments)
          that.next = res.data.next
          if (res.data.next == null) {
            that.loading = false
            that.finished = true
          }
        })
        that.$api.comment.count(params).then(res => {
          that.commentsCount = res.data
        })
      },
      loadMore () {
        let that = this
        if (that.next) {
          that.loading = true
          let url = that.next.split('/api/')[1] // 截掉前面的域名和 /api/ 部分
          that.$api.normal.load(url).then(res => {
            window.console.log("获取到了下一页内容")
            window.console.log(res)
            that.comments = that.comments.concat(res.data.results)
            that.next = res.data.next
            that.loading = false
            if (that.next === null) {
              that.finished = true
            }
          })
        }
      },
      replyTo (name, parent, applabel, classname, objectid) {
        this.replyToUserName = name
        this.parent = parent
        this.applabel = applabel
        this.classname = classname
        this.objectid = objectid
        this.$refs.commentInput.focus()
      },
      commentClosed () {
        this.closeComments()
      },
      // removeComment (commentId) {
      //   window.console.log("收到删除确认")
      //   let that = this
      //   that.$api.comment.close(commentId).then(res => {
      //     window.console.log("关闭comment成功")
      //     window.console.log(res)
      //     this.commentsCount -= 1
      //     Toast.success("评论已删除")
      //     that.closeComments()
      //   })
      // },
      onBlur () {
        if (this.commentValue.length == 0) {
          this.replyToUserName = ''
          this.parent = null
          this.applabel = this.commentApplabel
          this.classname = this.commentClassname
          this.objectid = this.commentObjectid
        }
      },
      submit () {
        let that = this
        if (that.commentValue.length > 0) {
          let params = {
            applabel: that.applabel,
            classname: that.classname,
            objectid: that.objectid,
            content: that.commentValue,
            parent: that.parent
          }
          that.$api.comment.create(params).then(res => {
            // Notify({ type: 'success', message: '评论发表成功' })
            Toast.success("评论发表成功")
            this.$emit('comment-created')
            that.commentValue = ''
            that.commentsCount += 1
            if (that.classname == 'comment') {
              // 如果是评论给评论
              // that.$refs['commentThread' + that.parent][0].getComment()
            } else {
              // that.comments.unshift(res.data)
            }
            window.console.log(res)
          })
        } else {
          Toast.fail('请写下评论')
        }
      },
      closeComments () {
        this.$emit('close-comments')
      }
    },
    mounted() {
    }
  }
</script>

<style lang="css" scoped>
  ::-webkit-scrollbar {
    width: 0;
    height: 0;
    color: transparent;
  }
  div {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .head {
    position:fixed;
    height:30px;
    padding-top:12px;
    border-top-left-radius:10px;
    border-top-right-radius:10px;
    z-index:20000;
    width:100%;
    background:#fff;
    border-bottom:1px solid #eee;
  }
  .bottom-bar {
    position:fixed;
    bottom:0px;
    z-index:20000;
    width:100%;
    background:#fff;
    padding: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);
    border-top:1px solid #eee
  }
</style>
